module.exports = __webpack_public_path__ + "static/media/user_profile_bg.bfb7c70a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/inar2/images/user_profile_bg.jpg
// module id = 2437
// module chunks = 0